import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { Footer } from "src/Modules/MainMenu";
import NavBar from "src/Modules/MainMenu/components/NavBar/NavBar";
import { RootState } from "src/store";

export default function Layout() {
  const isIntegerated = useSelector((state:RootState)=>state.auth.isIntegrated);
  return (
    <div className="flex min-h-screen w-full flex-col relative">
      <div className="w-full border-b border-border-subtle">
        <NavBar/>
      </div>
      <div className="flex flex-1 flex-col relative min-h-[80dvh] bg-background-default">
        <Outlet />
      </div>
      <div className="flex items-center justify-center bg-background-minimal font-thin text-xs">
        {!isIntegerated && <Footer/>}
      </div>
    </div>
  );
}
